import axios from 'axios';
import { toast } from 'react-toastify';
import countries from 'countries-list';

export const onEditCustomers = async ({
    values,
    customer,
    setLoading,
    setShow,
    fetchCustomers,
    setCustomer,
    t,
}) => {
    const isBusiness = values?.accountType != '1';
    const isVATRegistered = values?.isVATRegistred === 'true' || values?.isVATRegistred === true;

    if (isBusiness && isVATRegistered && !values?.vatNumber) {
        return toast.error(t('Please enter your VAT number'));
    }

    const countryCode = values.country === 'USA'
        ? 'US'
        : Object.entries(countries.countries).find(
            ([, val]) => val.name === values.country
        )?.[0] || '';

    if (!isBusiness || !isVATRegistered) {
        values.vatNumber = '';
    } else {
        values.vatNumber = values.vatCountryCode + values.vatNumber;
    }

    try {
        setLoading(true);
        await axios.put('/admin/user', {
            id: customer?.customerId,
            CountryCode: values.vatCountryCode,
            ...values,
        });

        setShow(prev => ({ ...prev, show: false }));
        await fetchCustomers();
        setCustomer({ customerId: customer?.customerId, ...values });
        toast.success(t('Customer updated successfully'));
    } catch (err) {
        toast.error(err?.response?.data?.message);
    } finally {
        setLoading(false);
    }
};
